import { render, staticRenderFns } from "./SalesTaxMenu.vue?vue&type=template&id=28ce599b&scoped=true&"
import script from "./SalesTaxMenu.vue?vue&type=script&lang=js&"
export * from "./SalesTaxMenu.vue?vue&type=script&lang=js&"
import style0 from "./SalesTaxMenu.vue?vue&type=style&index=0&id=28ce599b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ce599b",
  null
  
)

export default component.exports